<template>
  <v-app>
    <router-view></router-view>
  </v-app>  
</template>

<script setup>

</script>
<style>
  @import url('@/assets/css/styles.css');
</style>